Shopware.Component.extend('sw-cms-el-acris-blog-title', 'sw-cms-el-text', () => import('./component'));
Shopware.Component.extend('sw-cms-el-config-acris-blog-title', 'sw-cms-el-config-text', () => import('./config'));
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-title',
    label: 'acris-blog.elements.blogTitle.label',
    component: 'sw-cms-el-acris-blog-title',
    configComponent: 'sw-cms-el-config-acris-blog-title',
    previewComponent: 'sw-cms-el-preview-acris-blog-title',
    defaultConfig: {
        content: {
            source: 'static',
            value: '<h1>Lorem ipsum dolor sit amet.</h1>',
        },
        verticalAlign: {
            source: 'static',
            value: null,
        }
    }
});